import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react'
import DataTable from 'react-data-table-component'
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useGetProfileQuery } from '../../redux/api/profileApi/profileApi';
import { selectAuth, setActiveDropDownTab, setActiveTab } from '../../redux/features/authSlice';
import { IAuthUser } from '../../redux/features/authSlice/authSlice.types';
import jwt_decode from 'jwt-decode';
import { useGetPaymentRequestListQuery, useGetPaymentRequestQuery } from '../../redux/api/paymentApi/paymentApi';
import CustomLoading from '../../components/CustomLoading';
import { toast } from 'react-toastify';
import { ImPrinter } from 'react-icons/im';
import { VscPreview } from 'react-icons/vsc';
import CustomModal from '../../components/CustomModal';
import ReactToPrint from 'react-to-print';
import invoice_img1 from '../../assets/images/invoice_img1.svg';
import invoice_img2 from '../../assets/images/invoice_img2.svg';
import logo from '../../assets/images/tasnuva_courier.png';
import { MdAddIcCall } from 'react-icons/md';
import { AiOutlineGlobal, AiOutlineMail } from 'react-icons/ai';
import { BsFillBuildingsFill } from 'react-icons/bs';

const statusColor = {
    Requested: 'bg-[#22B7F2]/10 text-[#22B7F2]',
    InProgress: 'bg-[#F2DC6D]/10 text-[#F2DC6D]',
    Completed: 'bg-[#00E600]/10 text-[#00E600]',
    Cancelled: 'bg-[#FE0003]/10 text-[#FE0003]',
};

const InvoiceList = () => {
    const { token } = useSelector(selectAuth);
    const authData: IAuthUser = token ? jwt_decode(token) : null;
    const { data: profileData, isLoading: profileLoading } = useGetProfileQuery(
        authData?.id
    );
    const permissions: string[] = profileData?.permissions
        ? JSON.parse(profileData?.permissions)
        : [];

    const dispatch = useDispatch();
    const { pathname } = useLocation();
    const { data: paymentRequestList, isLoading: paymentListLoading } = useGetPaymentRequestListQuery(authData?.id);
    const [selectedPaymentRequest, setSelectedPaymentRequest] = useState(null);
    const { data: paymentRequest, isLoading: paymentLoading } = useGetPaymentRequestQuery(selectedPaymentRequest);
    const [showModal, setShowModal] = useState(false);

    const ref = useRef();

    const columns = [
        {
            name: "Invoice Id",
            selector: (row) => row?.id,
            sortable: true,
        },
        {
            name: "Invoice Date",
            selector: (row) => moment(row.invoiceDate).format("DD-MM-YYYY"),
            sortable: true,
        },

        {
            name: "Collected Amount",
            selector: (row) => row.collect_amount_sum,
            sortable: true,
        },
        {
            name: "Fees",
            selector: (row) => row.delivery_charge_sum,
        },
        {
            name: "Recieveable Amount",
            selector: (row) => row.product_amount_sum,
        },
        {
            name: "Status",
            selector: (row) => (
                <div
                    className={`py-1 w-20 text-center rounded ${statusColor[row?.payment_status]
                        }`}
                >
                    {row?.payment_status}
                </div>
            ),
            sortable: true,
        },
        {
            name: "Action",
            cell: (row) => (
                <div
                    onClick={() => {
                        if (permissions?.includes("DownloadInvoiceList")) {
                            setSelectedPaymentRequest(row?.id);
                            setShowModal(true);
                        } else {
                            toast.info("You have not permitted!");
                        }
                    }}
                    className={`flex flex-row gap-2 items-center justify-center py-1 w-24 text-center rounded border bg-secondary/10 border-secondary text-secondary hover:bg-secondary cursor-pointer transition-all  hover:animate-pulse hover:text-white`}
                >
                    <VscPreview /> Preview
                </div>

            ),
        },
    ];

    useEffect(() => {
        if (pathname === "/invoices-list") {
            dispatch(setActiveTab("Invoices List"));
            dispatch(setActiveDropDownTab("Invoices List"));
        }
    }, [dispatch, pathname]);

    return (
        <div className="w-full flex flex-col gap-10">
            <div className="bg-white shadow-lg rounded-lg p-4 justify-between flex flex-row gap-10">
                <div className="flex flex-col justify-between w-full gap-4">
                    <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
                        <div className="text-2xl font-bold text-text_1">Invoice List</div>

                    </div>
                    <div className="flex flex-row gap-4 items-center w-full">
                        <div className='text-text_2 italic text-lg'>List of Invoices for Tracking and Management.</div>
                    </div>
                </div>
                <div className="h-40 hidden lg:flex">
                    <img
                        src="https://res.cloudinary.com/di23omfvx/image/upload/v1692428968/self_driving_car_Road_1_npjom3.gif"
                        alt="self drive"
                        className="h-full w-full"
                    />
                </div>
            </div>
            <div className="overflow-x-auto bg-white shadow-lg rounded-lg p-2">
                <DataTable
                    title="Invoice List"
                    columns={columns}
                    data={paymentRequestList}
                    pagination
                    persistTableHead
                    highlightOnHover
                />
            </div>

            <CustomModal
                showModal={showModal}
                setShowModal={setShowModal}
                submitButton={false}
                closeButton={false}
                handleSubmit={() => window.print()}
                title={"Invoice ID: " + selectedPaymentRequest}
            >
                <div ref={ref} className='p-5 w-full h-[100vh] relative bg-[#f8f8f8]'>
                    <div className='w-full flex flex-col items-end'>
                        <div className='w-72'>
                            <img src={logo} alt="logo" className='h-full w-full' />
                        </div>
                        <div className='flex flex-row items-center gap-4 text-text_2 text-lg mt-5'>
                            <MdAddIcCall />
                            09610 003 030
                        </div>
                        <div className='flex flex-row items-center gap-4 text-text_2 text-lg mt-2'>
                            <AiOutlineGlobal />
                            www.tasnuvaraha.com
                        </div>
                        <div className='flex flex-row items-center gap-4 text-text_2 text-lg mt-2'>
                            <AiOutlineMail />
                            tasnuvaraha35@gmail.com
                        </div>
                        <div className='flex flex-row items-center gap-4 text-text_2 text-lg mt-2'>
                            <BsFillBuildingsFill />
                            Islam Tower, Hatirjheel, Rampura Dhaka-1219
                        </div>
                    </div>
                    <div className="mt-20 bg-white p-2 rounded-lg">
                        <div className="flex flex-row gap-2 justify-between font-semibold text-sm">
                            <div className="w-1/6">Order ID</div>
                            <div className="w-1/6">Customer Name</div>
                            <div className="w-1/6">Weight</div>
                            <div className="w-1/6">Quantity</div>
                            <div className="w-1/6">Collected Amount</div>
                            <div className="w-1/6">Date</div>
                        </div>
                        <hr className="my-2 border-secondary" />

                        {paymentRequest?.payment_parcel?.map((paymentInfo, index) => (
                            <div key={index} className='my-3'>
                                <div key={index} className={`${index === 34 ? "mt-20" : ""} flex flex-row gap-2 justify-between items-center text-xs`}>
                                    <div className="w-1/6">{paymentInfo?.parcel?.order_id}</div>
                                    <div className="w-1/6">{paymentInfo?.parcel?.customer_name}</div>
                                    <div className="w-1/6">{paymentInfo?.parcel?.weight} kg</div>
                                    <div className="w-1/6">{paymentInfo?.parcel?.quantity}</div>
                                    <div className="w-1/6">{paymentInfo?.parcel?.collect_amount}</div>
                                    <div className="w-1/6">{moment(paymentInfo?.parcel?.created_at).format('ll')}</div>
                                </div>
                                {index === 33 && <div className='break-after-page' />}
                            </div>
                        ))}

                    </div>

                    <div className='absolute top-0 left-0 w-[60%]'>
                        <img src={invoice_img1} alt='invoice one' className='w-full h-full' />
                    </div>
                    <div className='absolute bottom-0 right-0 w-[40%]'>
                        <img src={invoice_img2} alt='invoice one' className='w-full h-full' />
                    </div>
                    <div className='absolute bottom-5 left-5 text-text_2 text-lg'>
                        {moment().format('LLL')}
                    </div>
                </div>
                <div className='mt-10 flex w-full justify-end gap-5'>
                    <button
                        onClick={() => setShowModal(false)}
                        className={`py-2 w-28 text-center border border-[#606EBF] text-[#606EBF] rounded bg-[#606EBF]/10 flex items-center justify-center cursor-pointer transition-all hover:bg-[#606EBF] hover:animate-pulse hover:text-white`}
                    >
                        Close
                    </button>
                    <ReactToPrint content={() => ref.current} trigger={() => <div
                        className={`flex flex-row gap-2 w-28 items-center justify-center py-1 text-center rounded border bg-secondary/10 border-secondary text-secondary hover:bg-secondary cursor-pointer transition-all  hover:animate-pulse hover:text-white`}
                    >
                        <ImPrinter /> Print
                    </div>} />

                </div>
            </CustomModal>

            {(paymentListLoading || profileLoading || paymentLoading) && <CustomLoading />}
        </div>
    )
}

export default InvoiceList